import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="ppt" transform="translate(-565 -294)">
        <g id="file-extension" transform="translate(565 294)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(-19.329)"
            fill="#ca513f"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-189.894 -0.179)"
            fill="#954313"
          />
        </g>
        <path
          id="Контур_816"
          data-name="Контур 816"
          d="M-4.57-1.623V-.266h-.964v-4h1.6a1.859,1.859,0,0,1,.812.169,1.273,1.273,0,0,1,.547.481,1.313,1.313,0,0,1,.194.707,1.157,1.157,0,0,1-.419.935,1.738,1.738,0,0,1-1.15.35Zm0-.745h.632a.6.6,0,0,0,.427-.14.521.521,0,0,0,.147-.4.643.643,0,0,0-.151-.448.535.535,0,0,0-.412-.17H-4.57Zm3.718.745V-.266h-.964v-4h1.6A1.859,1.859,0,0,1,.592-4.1a1.273,1.273,0,0,1,.547.481,1.313,1.313,0,0,1,.194.707,1.157,1.157,0,0,1-.419.935,1.738,1.738,0,0,1-1.15.35Zm0-.745H-.22a.6.6,0,0,0,.427-.14.521.521,0,0,0,.147-.4A.643.643,0,0,0,.2-3.351a.535.535,0,0,0-.412-.17H-.851ZM5.043-3.521h-1.2V-.266H2.878V-3.521H1.7v-.745H5.043Z"
          transform="translate(575.625 309)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default memo(Icon);
